import { render, staticRenderFns } from "./ScoreboardLiveAmerican.vue?vue&type=template&id=3b80286c&scoped=true"
import script from "./ScoreboardLiveAmerican.vue?vue&type=script&lang=js"
export * from "./ScoreboardLiveAmerican.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardLiveAmerican.vue?vue&type=style&index=0&id=3b80286c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80286c",
  null
  
)

export default component.exports